import React from "react";
import { LAYER_PROPS } from "./layer_const.js";
import LayerFilter from "./LayerFilter.jsx";
import LayerPaint from "./LayerPaint.jsx";
import LayerLayout from "./LayerLayout.jsx";
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";
import Select from "../../../../common/Select.jsx";
import ToggleSwitch from "../../../../common/ToggleSwitch.jsx";
import AdvancedSetting from "../component/AdvancedSetting.jsx";

function LayerSetting({updateField, data, index, settings}) {
  const {id, type, source, layerName, layerGroup, layerDefault, layerVisibility, advancedSetting} = data;
  const sourceFields = settings.sourceFields || []
  const sourceOptions = sourceFields.map((s) => ({value: s.field_label, label: s.field_label}))
  const currentLayers = settings.layerFields || []

  const toggleGroupDefaultSetting = (layer) => {
    if (currentLayers && layer){
      if (layer.layerDefault === true){
        updateField(`layerFields.${index}.layerDefault`, false)
      } else {
        currentLayers.map((l, idx) => {return {...l, index: idx}})
                      .filter((l) => layer.layerGroup !== "" && l.layerGroup === layer.layerGroup && l.layerDefault === true)
                      .forEach((l) => updateField(`layerFields.${l.index}.layerDefault`, false));
        updateField(`layerFields.${index}.layerDefault`, true);
      }
    }
  }

    return (
      <div className='w-100'>
          <label className="col-xs-12">
            {LAYER_PROPS.layerName.title}
            <MapboxHelpTooltip description={LAYER_PROPS.layerName.description} />
            <input
              type="text"
              className="form-control"
              value={layerName}
              onChange={(e) => updateField(`layerFields.${index}.layerName`, e.target.value)}
            />
          </label>
          <label className="col-xs-12">
            {LAYER_PROPS.layerGroup.title}
            <MapboxHelpTooltip description={LAYER_PROPS.layerGroup.description} />
            <input
              type="text"
              className="form-control"
              value={layerGroup || LAYER_PROPS.layerGroup.default}
              onChange={(e) => updateField(`layerFields.${index}.layerGroup`, e.target.value)}
            />
          </label>
          <label className="col-xs-12">
            {LAYER_PROPS.layerDefault.title}
            <ToggleSwitch
                isOn={layerDefault || false}
                name={`layerDefault-${id}`}
                handleToggle={(e) => toggleGroupDefaultSetting(data)}
            />
          </label>
          <label className="col-xs-12">
            {LAYER_PROPS.type.title}
            <MapboxHelpTooltip description={LAYER_PROPS.type.description} />
            <Select
              value={type}
              options={LAYER_PROPS.type.options}
              onChange={(v) => updateField(`layerFields.${index}.type`, v)}
            />
          </label>
          <label className="col-xs-12">
            {LAYER_PROPS.source.title}
            <MapboxHelpTooltip description={LAYER_PROPS.source.description} />
            <Select
              value={source}
              options={sourceOptions}
              onChange={(v) => updateField(`layerFields.${index}.source`, v)}
            />
          </label>
          <label className="col-xs-12 col-md-12 d-flex align-items-center">
            {LAYER_PROPS.layerVisibility.title}
            <MapboxHelpTooltip description={LAYER_PROPS.layerVisibility.description} className='mr-1' />
            <ToggleSwitch
                isOn={layerVisibility}
                name={`layerVisibility-${id}`}
                handleToggle={(e) => updateField(`layerFields.${index}.layerVisibility`, !layerVisibility)}
            />
          </label>
          <LayerFilter index={index} layerField={data} updateField={updateField} />
          <LayerPaint index={index} layerField={data} updateField={updateField} />
          <LayerLayout index={index} layerField={data} updateField={updateField} />
          <AdvancedSetting 
            update={(val) => updateField(`layerFields.${index}.advancedSetting`, val)} 
            title={LAYER_PROPS.advancedSetting.title} 
            description={LAYER_PROPS.advancedSetting.description}
            setting={advancedSetting}
          />
      </div>
    )
}

export default LayerSetting;